export enum FeatureFlag {
  ADD_SMART_SEARCH_FORM = 'ADD_SMART_SEARCH_FORM',
}

export type FeatureConfig = Record<string, boolean>;
